export const SET_BATCHES = 'SET_BATCHES'
export const SET_BATCH_QUANTITIES = 'SET_BATCH_QUANTITIES'



// WEBPACK FOOTER //
// ./src/types/batch.js